import type { PropsWithChildren } from 'react';
import React from 'react';

import type { Announcement } from '@swf/help';
import { AnnouncementList, ContactUs, Search, SearchSkeleton } from '@swf/help';

import styles from './HelpContainer.scss';
import { useDelayedSwitch } from './useDelayedSwitch';

interface Props {
  announcements?: Announcement[];
  showTitle?: boolean;
  isLoading: boolean;
  isPreloaded: boolean;
  preloader: JSX.Element;
}

export const HelpContainerSkeleton: React.FC<PropsWithChildren<Pick<Props, 'showTitle'>>> = ({
  children,
  showTitle = false
}) => (
  <div className={styles.content}>
    <SearchSkeleton showTitle={showTitle} />
    {children}
  </div>
);

const HelpContainer: React.FC<PropsWithChildren<Props>> = ({
  children,
  announcements,
  showTitle = false,
  isLoading,
  isPreloaded,
  preloader
}) => {
  const isSwitching = useDelayedSwitch(isLoading || !isPreloaded);

  if (isSwitching || isLoading || !isPreloaded) {
    return <HelpContainerSkeleton showTitle={showTitle}>{preloader}</HelpContainerSkeleton>;
  }

  return (
    <div className={styles.content}>
      <Search showTitle={showTitle} />
      {!!announcements?.length && <AnnouncementList announcements={announcements} />}
      {children}
      <ContactUs />
    </div>
  );
};

export default HelpContainer;
